import { oz } from '@weft/utils';

export const MONTHS_ENUM = Object.freeze({
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
} as const);

export const MONTHS = Object.freeze([
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const);

export const MonthsSchema = oz.enum(MONTHS);

export type Months = oz.infer<typeof MonthsSchema>;